module.exports = __webpack_public_path__ + "img/jobmule_skills.85c05a39.png";